
import './App.css';
import Footer from './Components/Footer/Footer';
import Hero from './Components/Hero/Hero';
import Navbar from './Components/Navbar/Navbar';


function App() {

 
  return (
    <div className="App" >
 <Navbar/>
 <Hero/>
 <Footer/>
    </div>
  );
}

export default App;
